import { Component } from '@angular/core';
import {environment as env} from "@env";


@Component({
  selector: 'app-edenred-one-header',
  imports: [],
  templateUrl: './edenred-one-header.component.html',
  styleUrl: './edenred-one-header.component.scss',
})
export class EdenredOneHeaderComponent {
  public readonly externalUrl = env.urlEdenredOne;
}
